import { loadStripe } from '@stripe/stripe-js'

export const stripePromise = loadStripe(
    'pk_test_51RkozqC29ROASaRZt5oTyyU6L3oJLU9cltN74btdSRwk9maCfrnxELliymU3LTSGEUDZlDRBXurRgXvMJzugCg2a00iXQ5oPXR'
)

// Live publishable key
// export const stripePromise = loadStripe(
//     'pk_live_bTKAdFiIGvJ2wi8InXsfup5X'
// )